(function () {
  const initHero = (section) => {
    if (!section || !section?.classList.contains("hero-section")) {
      return;
    }

    const slider = section.querySelector(".hero__media--slider");

    if (!slider) return;

    const sliderSpeed = Number(slider.dataset?.sliderSpeed || 15000);
    const sliderSpeedMob = sliderSpeed * 0.8;
    const sliderDirection = slider.dataset?.sliderDirection || "right_to_left";
    const reverseDirection = sliderDirection === "left_to_right" ? true : false;

    // SW-CUSTOM START: 1 Slide pro Item (statt Ticker-Modus)
    new Swiper(slider, {
      loop: true,
      allowTouchMove: false,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: Math.round(sliderSpeedMob * 0.06),
      autoplay: {
        delay: sliderSpeedMob - Math.round(sliderSpeedMob * 0.06),
        disableOnInteraction: false,
        reverseDirection: reverseDirection,
      },
      breakpoints: {
        576: {
          speed: Math.round(sliderSpeed * 0.06),
          autoplay: {
            delay: sliderSpeed - Math.round(sliderSpeed * 0.06),
          },
        },
      },
    });
    // SW-CUSTOM END
  };

  initHero(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initHero(event.target);
  });
})();